import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is this really free?",
    a: "Yes — completely. There's no cost, no credit card, and no obligation. We use the checkup to show you what we'd focus on if we were managing your growth. If it's helpful and you'd like to explore working together, great. If not, you still walk away with a clear picture of where your practice stands.",
  },
  {
    q: "How long does the checkup take to receive?",
    a: "Most checkups are delivered within 3 business days. Timing can vary slightly depending on queue volume and the complexity of your online presence, but we'll keep you updated.",
  },
  {
    q: "What do you actually review?",
    a: "We look at your website, Google Business Profile, online visibility, review signals, and how your new-patient pipeline is set up — from the first impression a prospective patient sees to the point they schedule. We also include an AI visibility snapshot to show how your practice appears in AI-powered search tools.",
  },
  {
    q: "Is this a sales pitch disguised as an audit?",
    a: "No. The checkup is a genuine review of your practice's growth system. You'll receive specific, actionable observations — not a generic deck. If you'd like help acting on the findings, we're here. But the checkup stands on its own.",
  },
  {
    q: "Who is this best suited for?",
    a: "Established dental practices doing $80K+ per month in collections who want to grow but aren't sure what's actually holding them back. If you're already investing in marketing and want clarity on what's working and what isn't, this is built for you.",
  },
  {
    q: "Will you contact me after I submit?",
    a: "Yes — we'll reach out by email to deliver your checkup and offer to walk through it with you on a short call. There's no pressure and no hard sell. If you'd prefer email-only, just let us know.",
  },
];

const CheckupFAQ = () => (
  <section className="py-14 md:py-20 bg-secondary">
    <div className="max-w-2xl mx-auto section-padding">
      <div className="text-center mb-8">
        <p className="text-accent font-semibold text-xs tracking-wide uppercase mb-1.5">
          Common Questions
        </p>
        <h2 className="text-xl md:text-2xl font-bold text-foreground tracking-tight">
          Frequently Asked Questions
        </h2>
      </div>

      <Accordion type="single" collapsible className="space-y-2">
        {faqs.map((faq, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="bg-card border border-border rounded-lg px-5 data-[state=open]:shadow-sm"
          >
            <AccordionTrigger className="text-sm font-semibold text-foreground text-left py-4 hover:no-underline">
              {faq.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-4">
              {faq.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default CheckupFAQ;
